import styled from 'styled-components';

export const TableContainer = styled.div`
  grid-area: History;
  margin-top: 15px;
`;

